import SecretAuth from './src/secret-auth';

export default SecretAuth;
